export function updateSelectedRows(row, selectedRows) {
    const index = selectedRows.findIndex(selectedRow => selectedRow === row);
    const selected = selectedRows.slice();

    if (~index) {
        selected.splice(index, 1);
    } else {
        selected.push(row);
    }

    return selected;
}

export default (state, action) =>
    Object.assign({}, state, {
        selectedRows: updateSelectedRows(action.row, state.selectedRows)
    });



// WEBPACK FOOTER //
// ./src/js/modules/DataTable/reducers/selectRow.js